"use strict";

exports.__esModule = true;
exports.default = void 0;
var _emotion = require("emotion");
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactEmotion = require("react-emotion");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var content = /*#__PURE__*/
(0, _reactEmotion.css)({
  height: '100%',
  padding: 45
}); // need to design this better, time constraints

var Hero = function Hero(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    fullBleed = _ref.fullBleed;
  return _react.default.createElement("section", {
    className: className,
    style: style
  }, fullBleed ? children : _react.default.createElement("div", {
    className: (0, _emotion.css)(content)
  }, children));
};
Hero.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  style: _propTypes.object,
  fullBleed: _propTypes.bool
};
var _default = Hero;
exports.default = _default;